import { gql, TypedDocumentNode } from "@apollo/client";

import { QueryScanArgs } from "types/generated";

import { ScanDetailItem } from "./types";

type GetScanDetailData = {
  scan: ScanDetailItem;
};

export const GET_SCAN_DETAIL: TypedDocumentNode<GetScanDetailData, QueryScanArgs> = gql`
  query GetScanDetail($id: ID!) {
    scan(id: $id) {
      id
      name
      description
      labels
      workerPool
      workerPoolName
      createdAt
      updatedAt
      providerConfigs {
        type
        version
        integration
        integrationName
        config {
          ... on AWSScanSettings {
            region
          }
        }
      }
      scope {
        type
      }
      space {
        id
        name
      }
      latestRun {
        id
        state
        resourceCount
        resourceStats {
          managed
          unmanaged
        }
        stateChangedAt
      }
    }
  }
`;
